import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../../components/Layout/Header/Header";
import Footer from "../../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../../components/Common/ScrollTop";
import OffWrap from "../../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../../components/Common/Breadcumb";
import SearchModal from "../../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../../utils/fetchData";
import Accreditation from "../../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../../utils/getDomainData";

const OTPRI_LibraryPolicy = () => {
    const [data, setData] = useState([]);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];
    const { fontSize } = useFontSize();

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.libraryPolicy, setData);
    }, [currentDomain]);

    // Function to render rich text content
    const renderRichText = (content) => {
        if (!content || !Array.isArray(content)) return null;
        
        return content.map((block, index) => {
            if (block.type === 'paragraph') {
                return (
                    <p key={index} className="mb-3">
                        {block.children?.map((child, childIndex) => {
                            if (child.type === 'text') {
                                let text = child.text;
                                
                                // Apply formatting
                                if (child.bold) {
                                    text = <strong key={childIndex}>{text}</strong>;
                                }
                                if (child.italic) {
                                    text = <em key={childIndex}>{text}</em>;
                                }
                                if (child.underline) {
                                    text = <u key={childIndex}>{text}</u>;
                                }
                                
                                return text;
                            }
                            return child.text || "";
                        })}
                    </p>
                );
            } else if (block.type === 'list') {
                const ListTag = block.format === 'ordered' ? 'ol' : 'ul';
                
                return (
                    <ListTag key={index} className="library-list">
                        {block.children?.map((listItem, itemIndex) => {
                            if (listItem.type === 'list-item') {
                                return (
                                    <li key={itemIndex}>
                                        {listItem.children?.map((child, childIndex) => {
                                            if (child.type === 'text') {
                                                let text = child.text;
                                                
                                                // Apply formatting
                                                if (child.bold) {
                                                    text = <strong key={childIndex}>{text}</strong>;
                                                }
                                                if (child.italic) {
                                                    text = <em key={childIndex}>{text}</em>;
                                                }
                                                if (child.underline) {
                                                    text = <u key={childIndex}>{text}</u>;
                                                }
                                                
                                                return text;
                                            }
                                            return child.text || "";
                                        })}
                                    </li>
                                );
                            }
                            return null;
                        })}
                    </ListTag>
                );
            }
            return null;
        });
    };

    const libraryData = data?.data?.attributes;

    return (
        <React.Fragment>
            <Helmet>
                <title>Library Policy | Oil Technological & Pharmaceutical Research Institute | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="Library Policy at JNTUA Oil Technological and Pharmaceutical Research Institute (OT&PRI) - Learn about our library facilities, resources, and policies."
                />
                <meta
                    name="keywords"
                    content="OTPRI Library Policy, Oil Technological, Pharmaceutical Research Institute, JNTUA, Library Facilities, Academic Resources"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .library-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .library-section {
                        background: #fff;
                        padding: 50px 0;
                    }
                    .section-heading {
                        color: #007bff;
                        font-weight: bold;
                        margin-bottom: 30px;
                        border-bottom: 3px solid #007bff;
                        padding-bottom: 10px;
                        display: inline-block;
                    }
                    .library-content {
                        background: #f8f9fa;
                        padding: 40px;
                        border-radius: 10px;
                        margin-bottom: 40px;
                        border-left: 5px solid #007bff;
                        line-height: 1.8;
                    }
                    .library-content p {
                        margin-bottom: 15px;
                        color: #333;
                        font-size: 1rem;
                    }
                    .library-list {
                        list-style: none;
                        padding: 0;
                        margin-top: 20px;
                    }
                    .library-list li {
                        background: #fff;
                        padding: 15px 20px;
                        margin-bottom: 10px;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        border-left: 4px solid #007bff;
                        position: relative;
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    .library-list li:hover {
                        transform: translateX(5px);
                        box-shadow: 0 5px 15px rgba(0,0,0,0.15);
                    }
                    .library-list li:nth-child(2n) {
                        border-left-color: #28a745;
                    }
                    .library-list li:nth-child(3n) {
                        border-left-color: #ffc107;
                    }
                    .photos-section {
                        padding: 40px 0;
                        background: #f8f9fa;
                    }
                    .photo-gallery {
                        margin-top: 30px;
                    }
                    .photo-item {
                        margin-bottom: 30px;
                    }
                    .photo-card {
                        background: #fff;
                        border-radius: 15px;
                        overflow: hidden;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    .photo-card:hover {
                        transform: scale(1.02);
                        box-shadow: 0 15px 40px rgba(0,0,0,0.3);
                    }
                    .photo-card img {
                        width: 100%;
                        height: auto;
                        display: block;
                    }
                    .no-content {
                        text-align: center;
                        color: #666;
                        font-style: italic;
                        padding: 40px 20px;
                        background: #f8f9fa;
                        border-radius: 8px;
                        margin: 20px 0;
                    }
                    .statistics-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                        gap: 20px;
                        margin-top: 30px;
                    }
                    .stat-card {
                        background: #fff;
                        padding: 25px;
                        border-radius: 10px;
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                        text-align: center;
                        border-top: 4px solid #007bff;
                        transition: transform 0.3s ease;
                    }
                    .stat-card:hover {
                        transform: translateY(-5px);
                    }
                    .stat-card:nth-child(2n) {
                        border-top-color: #28a745;
                    }
                    .stat-card:nth-child(3n) {
                        border-top-color: #ffc107;
                    }
                    .stat-number {
                        font-size: 2rem;
                        font-weight: bold;
                        color: #007bff;
                        margin-bottom: 10px;
                    }
                    .stat-label {
                        color: #666;
                        font-weight: 500;
                    }
                `}
            </style>
            <div className="pageTopOffset">
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="Library Policy"
                    pageName="Library Policy"
                    breadcrumbsClass="breadcrumb-bg"
                />
                {/* breadcrumb-area-start */}
                {getMenu(currentDomain)}
                
                <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
                    <div className="container">
                        <div className="row">
                            <div className="col pl-20 md-pl-14">
                                <div className="row">
                                    <div className="rs-inner-blog col-lg-12">
                                        {/* Page Title */}
                                        <h1 className="library-title text-center mb-5">
                                            JNTUA-OTPRI Library Policy
                                        </h1>

                                        {/* Sections */}
                                        {libraryData?.section && libraryData.section.length > 0 && (
                                            <div className="library-sections">
                                                {libraryData.section.map((section, sectionIndex) => (
                                                    <div key={section.id || sectionIndex} className="library-section">
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <h2 className="section-heading">
                                                                    {section.title}
                                                                </h2>
                                                                
                                                                <div className="library-content">
                                                                    {renderRichText(section.content)}
                                                                    
                                                                    {/* Extract statistics from content */}
                                                                    {section.content && (
                                                                        <div className="statistics-grid">
                                                                            {section.content
                                                                                .filter(block => 
                                                                                    block.type === 'paragraph' && 
                                                                                    block.children?.[0]?.text?.includes('No.')
                                                                                )
                                                                                .map((statBlock, statIndex) => {
                                                                                    const text = statBlock.children?.[0]?.text || '';
                                                                                    const parts = text.split(':');
                                                                                    if (parts.length === 2) {
                                                                                        return (
                                                                                            <div key={statIndex} className="stat-card">
                                                                                                <div className="stat-number">
                                                                                                    {parts[1].trim()}
                                                                                                </div>
                                                                                                <div className="stat-label">
                                                                                                    {parts[0].replace('No.', 'Number').trim()}
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                    return null;
                                                                                })
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {/* Photos Section */}
                                        {libraryData?.photos && libraryData.photos.length > 0 && (
                                            <div className="photos-section">
                                                <h2 className="section-heading">Library Gallery</h2>
                                                <div className="photo-gallery">
                                                    <div className="row">
                                                        {libraryData.photos.map((photoGroup, groupIndex) => (
                                                            photoGroup.media?.data?.map((photo, photoIndex) => (
                                                                <div key={`${groupIndex}-${photoIndex}`} className="col-lg-6 col-md-6 col-sm-12 photo-item">
                                                                    <div className="photo-card">
                                                                        <img 
                                                                            src={`${imageBaseURL}${photo.attributes.url}`}
                                                                            alt={photo.attributes.alternativeText || `Library Image ${photoIndex + 1}`}
                                                                            loading="lazy"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Fallback if no data */}
                                        {(!libraryData?.section || libraryData.section.length === 0) && (
                                            <div className="no-content">
                                                <h3>Library Policy</h3>
                                                <p>Library policy information will be updated soon. Please check back later.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Accreditation />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop scrollClassName="scrollup orange-color" />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
};

export default OTPRI_LibraryPolicy;